export default {
  SOCKET: 'socket',
  RETHINK: 'rethink',
};
